/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isEventManagementForm } from "../Utils/FormUtils";
import { EventRegistrationCanceledFeedback, SuccessFeedback, WaitlistFeedback } from "./Feedback";
import { HtmlAttributes } from "../../../../Common/Constants/HtmlAttributes";
var SubmissionFeedbackProvider = /** @class */ (function () {
    function SubmissionFeedbackProvider() {
    }
    SubmissionFeedbackProvider.getSuccessFeedback = function (form, formElement, formSubmitProps) {
        if (isEventManagementForm(form)) {
            var eventSubmitButton = formElement.querySelector("[type=\"submit\"][".concat(HtmlAttributes.dataEventSubmissionType, "]"));
            var submissionType = eventSubmitButton === null || eventSubmitButton === void 0 ? void 0 : eventSubmitButton.getAttribute(HtmlAttributes.dataEventSubmissionType);
            switch (submissionType) {
                case "eventRegistrationCancellation":
                case "sessionRegistrationCancellation":
                    return EventRegistrationCanceledFeedback;
                case "waitlist":
                    return __assign(__assign({}, WaitlistFeedback), { message: formSubmitProps.WaitlistMessage || WaitlistFeedback.message });
            }
        }
        return __assign(__assign({}, SuccessFeedback), { message: formSubmitProps.SuccessMessage || SuccessFeedback.message });
    };
    return SubmissionFeedbackProvider;
}());
export { SubmissionFeedbackProvider };
